/**
 * BIRTHTREE PREVIEW - Canvas-basierte Live-Vorschau
 * Zeigt personalisierte Birthtree-Produkte mit Echtzeit-Rendering
 */

const BirthtreePreview = {
  // ========================================
  // KONFIGURATION (ANPASSBAR!)
  // ========================================
  config: {
    // Base-Produktbild
    baseImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/vorschaubild.png?v=1761572868',

    // Canvas-Dimensionen
    canvasWidth: 800,
    canvasHeight: 800,

    // Motiv-URLs (1-27)
    motivUrls: {
      1: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/1_c9955e33-eebc-42f3-a457-6a604e773329.png?v=1761572656',
      2: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/2_876b3ccc-3855-49cd-991b-c295e95a2afe.png?v=1761572656',
      3: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/3_8ee13ee2-24a3-4323-ba8e-8c2a2ff5cfcb.png?v=1761572656',
      4: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/4_86439b51-1b3f-444c-a6e4-6ff295f2a588.png?v=1761572656',
      5: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/5_619969e9-8ad0-433e-8a05-ec8d74ef64dc.png?v=1761572656',
      6: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/6_43b9ee95-00d6-450f-a17e-de966ffbad5f.png?v=1761572656',
      7: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/7_a64314a7-c91f-46a4-b239-c6e232b8eae8.png?v=1761572657',
      8: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/8_f417f82e-2dab-4167-b074-70c598a46977.png?v=1761572656',
      9: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/9_ae6a6252-ede4-49db-98a6-3afe3c212a3f.png?v=1761572656',
      10: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/10_e439e942-0903-4286-8be0-5b25cc0e4392.png?v=1761576033',
      11: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/11_05aa2be6-fc11-43a0-a94d-293518eb04e2.png?v=1761576033',
      12: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/12_2884a999-241e-4db7-bba3-a78ed103984b.png?v=1761576033',
      13: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/13_9e5cf5c8-3b91-4de9-bb09-19bb83e6de2c.png?v=1761576033',
      14: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/14_0e530cdb-132a-4f2c-b38f-3a58fb7290ef.png?v=1761576034',
      15: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/15_01183955-b0f6-4d3b-99d1-6090a0c7c740.png?v=1761576033',
      16: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/16_bc4d015c-c78e-4c93-a4b6-54bc07b73dab.png?v=1761576033',
      17: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/17_e262954c-3c7f-4052-b311-19c31bbf2116.png?v=1761576033',
      18: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/18_a8d05d91-c23c-404d-a40b-1c98ab4a2276.png?v=1761576033',
      19: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/19_0dc2a7c1-7623-4a0d-a895-274ea4958d94.png?v=1761576033',
      20: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/20_46e2e0cf-f2f7-408b-a76f-8339c27b2e99.png?v=1761576033',
      21: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/21_ac5b3711-05e1-44ed-8df4-1bca86f7b2b5.png?v=1761576033',
      22: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/22_8ff97f03-979d-4faa-a9e1-596625338e0f.png?v=1761576034',
      23: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/23_af84e685-9b86-443e-b86e-54fe59f9e3a6.png?v=1761576033',
      24: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/24_bbccac11-b8e2-4e34-8f11-aa2f95d6728c.png?v=1761576033',
      25: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/25_f73cec47-cc04-4b52-a5e9-f83eecf3ba60.png?v=1761576033',
      26: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/26_11009d07-f640-4dcf-9284-4706e3f50ee8.png?v=1761576032',
      27: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/27_ddf65d84-9634-4267-93ab-359205468e53.png?v=1761576033'
    },

    // Text-Positionen und Styles (basierend auf Musterbild)
    textConfig: {
      vorname: {
        x: 400,           // Zentriert
        y: 590,           // Vorname weiter nach unten
        fontSize: 52,     // Groß und prominent
        fontFamily: 'Halimun',
        color: '#4a4a4a', // Dunkelgrau
        align: 'center',
        baseline: 'middle'
      },
      datum: {
        x: 400,
        y: 640,           // Weiter nach unten verschoben
        fontSize: 36,
        fontFamily: 'Yanone Kaffeesatz',
        color: '#5a5a5a',
        align: 'center',
        baseline: 'middle'
      }
    },

    // Details-Zeile (Uhrzeit · Gewicht · Größe)
    detailsConfig: {
      x: 400,
      y: 695,             // Weiter nach unten verschoben
      fontSize: 28,
      fontFamily: 'Yanone Kaffeesatz',
      color: '#5a5a5a',
      align: 'center',
      baseline: 'middle',
      separator: ' · '    // Trennzeichen zwischen Details
    },

    // Motiv-Position und Größe
    motivConfig: {
      x: 400,             // Zentriert
      y: 400,             // Weiter nach unten verschoben
      maxWidth: 240,      // Max. Breite
      maxHeight: 240      // Max. Höhe
    }
  },

  // Interner State
  canvas: null,
  ctx: null,
  images: {
    base: null,
    motiv: null
  },
  fontsLoaded: false,
  isRendering: false,

  /**
   * Initialisierung
   */
  init() {
    // Canvas-Element finden
    this.canvas = document.getElementById('preview-canvas');
    if (!this.canvas) {
      console.error('Canvas element not found');
      return;
    }

    this.ctx = this.canvas.getContext('2d');

    // Event Listeners registrieren
    this.setupEventListeners();

    // Fonts vorladen
    this.loadFonts();

    // Base Image vorladen
    this.loadBaseImage();

    // Warenkorb-Integration einrichten
    this.setupCartIntegration();

    console.log('BirthtreePreview initialized');
  },

  /**
   * Event Listeners einrichten
   */
  setupEventListeners() {
    // Vorschau-Button
    const previewBtn = document.getElementById('preview-btn');
    if (previewBtn) {
      previewBtn.addEventListener('click', () => this.openPreview());
    }

    // Modal schließen
    const closeBtn = document.querySelector('.preview-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closePreview());
    }

    // Modal-Hintergrund klicken
    const modal = document.getElementById('preview-modal');
    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target.id === 'preview-modal') {
          this.closePreview();
        }
      });
    }

    // ESC-Taste zum Schließen
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closePreview();
      }
    });
  },

  /**
   * Fonts laden und auf Bereitschaft warten
   */
  async loadFonts() {
    try {
      // Warten bis Fonts geladen sind
      await document.fonts.ready;

      // Fonts explizit laden
      await document.fonts.load('52px Halimun');
      await document.fonts.load('36px "Yanone Kaffeesatz"');

      this.fontsLoaded = true;
      console.log('✓ Fonts loaded successfully');
    } catch (error) {
      console.error('Error loading fonts:', error);
      this.fontsLoaded = true; // Trotzdem weitermachen
    }
  },

  /**
   * Base-Produktbild vorladen
   */
  loadBaseImage() {
    this.images.base = new Image();
    this.images.base.crossOrigin = 'anonymous';

    this.images.base.onload = () => {
      console.log('✓ Base image loaded');
    };

    this.images.base.onerror = () => {
      console.error('✗ Failed to load base image');
    };

    this.images.base.src = this.config.baseImage;
  },

  /**
   * Motiv-Bild laden
   */
  loadMotiv(motivNumber) {
    return new Promise((resolve, reject) => {
      if (!motivNumber) {
        this.images.motiv = null;
        resolve();
        return;
      }

      const motivUrl = this.config.motivUrls[motivNumber];

      if (!motivUrl) {
        console.error(`Motiv ${motivNumber} not found`);
        this.images.motiv = null;
        resolve();
        return;
      }

      this.images.motiv = new Image();
      this.images.motiv.crossOrigin = 'anonymous';

      this.images.motiv.onload = () => {
        console.log(`✓ Motiv ${motivNumber} loaded`);
        resolve();
      };

      this.images.motiv.onerror = () => {
        console.error(`✗ Failed to load motiv ${motivNumber}`);
        this.images.motiv = null;
        resolve(); // Trotzdem weitermachen
      };

      this.images.motiv.src = motivUrl;
    });
  },

  /**
   * Vorschau-Modal öffnen
   */
  async openPreview() {
    if (this.isRendering) return;

    // Felder mit Warenkorb synchronisieren
    this.syncFieldsToCart();

    const modal = document.getElementById('preview-modal');
    const loading = document.getElementById('preview-loading');
    const canvas = this.canvas;

    // Modal anzeigen
    modal.classList.add('active');
    loading.style.display = 'block';
    canvas.style.display = 'none';

    // Kurz warten für Modal-Animation
    await new Promise(resolve => setTimeout(resolve, 100));

    // Vorschau rendern
    await this.renderPreview();

    // Canvas anzeigen
    loading.style.display = 'none';
    canvas.style.display = 'block';
  },

  /**
   * Vorschau-Modal schließen
   */
  closePreview() {
    const modal = document.getElementById('preview-modal');
    modal.classList.remove('active');
  },

  /**
   * Form-Daten auslesen
   */
  getFormData() {
    // Motiv aus Radio Buttons auslesen
    const motivRadio = document.querySelector('input[name="bt-motiv"]:checked');

    return {
      vorname: document.getElementById('bt-vorname')?.value || '',
      gewicht: document.getElementById('bt-gewicht')?.value || '',
      groesse: document.getElementById('bt-groesse')?.value || '',
      uhrzeit: document.getElementById('bt-uhrzeit')?.value || '',
      datum: document.getElementById('bt-datum')?.value || '',
      motiv: motivRadio?.value || ''
      // Samenart wird jetzt vom V2 Picker verwaltet
    };
  },

  /**
   * Warenkorb-Integration einrichten
   */
  setupCartIntegration() {
    // Hidden Fields ins Product Form einfügen
    const productForm = document.querySelector('form[action*="/cart/add"]');
    const hiddenFields = document.getElementById('bt-hidden-fields');

    if (productForm && hiddenFields) {
      // Hidden Fields ins Form verschieben
      productForm.appendChild(hiddenFields);
      console.log('✓ Hidden fields moved to product form');
    } else {
      console.warn('⚠ Product form or hidden fields not found');
    }

    // Bei Input-Änderungen automatisch synchronisieren
    const inputs = document.querySelectorAll('.bt-input');
    inputs.forEach(input => {
      input.addEventListener('change', () => this.syncFieldsToCart());
      input.addEventListener('blur', () => this.syncFieldsToCart());
    });

    // Bei Radio Button Änderungen synchronisieren
    const radioButtons = document.querySelectorAll('input[name="bt-motiv"]');
    radioButtons.forEach(radio => {
      radio.addEventListener('change', () => this.syncFieldsToCart());
    });

    // Bei Form Submit synchronisieren
    if (productForm) {
      productForm.addEventListener('submit', () => {
        this.syncFieldsToCart();
      });
    }

    console.log('✓ Cart integration setup complete');
  },

  /**
   * Felder mit Hidden Fields synchronisieren
   */
  syncFieldsToCart() {
    const formData = this.getFormData();

    // Datum von YYYY-MM-DD zu TT.MM.JJJJ konvertieren
    let datumFormatted = formData.datum;
    if (formData.datum && formData.datum.includes('-')) {
      const parts = formData.datum.split('-');
      if (parts.length === 3) {
        datumFormatted = `${parts[2]}.${parts[1]}.${parts[0]}`;
      }
    }

    // Hidden bt-motiv Field aktualisieren (für Rückwärtskompatibilität)
    const hiddenMotivField = document.getElementById('bt-motiv');
    if (hiddenMotivField) {
      hiddenMotivField.value = formData.motiv;
    }

    // Werte in Hidden Fields kopieren
    const hiddenFields = {
      'bt-hidden-vorname': formData.vorname,
      'bt-hidden-gewicht': formData.gewicht + (formData.gewicht ? ' g' : ''),
      'bt-hidden-groesse': formData.groesse + (formData.groesse ? ' cm' : ''),
      'bt-hidden-uhrzeit': formData.uhrzeit,
      'bt-hidden-datum': datumFormatted,
      'bt-hidden-motiv': formData.motiv ? `Motiv ${formData.motiv}` : ''
      // Samenart wird jetzt vom V2 Picker verwaltet
    };

    Object.keys(hiddenFields).forEach(id => {
      const field = document.getElementById(id);
      if (field) {
        field.value = hiddenFields[id];
      }
    });

    console.log('✓ Fields synced to cart:', formData);
  },

  /**
   * Hauptfunktion: Vorschau rendern
   */
  async renderPreview() {
    if (this.isRendering) return;
    this.isRendering = true;

    try {
      const ctx = this.ctx;
      const canvas = this.canvas;

      // Canvas leeren
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 1. Base-Bild zeichnen
      if (this.images.base && this.images.base.complete) {
        ctx.drawImage(this.images.base, 0, 0, canvas.width, canvas.height);
      } else {
        // Fallback: Weißer Hintergrund
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        console.warn('Base image not loaded, using white background');
      }

      // Form-Daten holen
      const formData = this.getFormData();

      // Datum formatieren (YYYY-MM-DD → TT.MM.JJJJ)
      let datumFormatted = formData.datum;
      if (formData.datum && formData.datum.includes('-')) {
        const parts = formData.datum.split('-');
        if (parts.length === 3) {
          datumFormatted = `${parts[2]}.${parts[1]}.${parts[0]}`;
        }
      }

      // 2. Motiv laden und zeichnen (wenn ausgewählt)
      if (formData.motiv) {
        await this.loadMotiv(formData.motiv);
        this.drawMotiv();
      }

      // 3. Vorname zeichnen
      if (formData.vorname) {
        this.drawText('vorname', formData.vorname);
      }

      // 4. Datum zeichnen
      if (datumFormatted) {
        this.drawText('datum', datumFormatted);
      }

      // 5. Details-Zeile zeichnen (Uhrzeit · Gewicht · Größe)
      this.drawDetailsLine(formData);

      console.log('✓ Preview rendered successfully');
    } catch (error) {
      console.error('Error rendering preview:', error);
    } finally {
      this.isRendering = false;
    }
  },

  /**
   * Text zeichnen
   */
  drawText(fieldName, text) {
    if (!text) return;

    const config = this.config.textConfig[fieldName];
    if (!config) return;

    const ctx = this.ctx;

    // Font-Style setzen
    ctx.font = `${config.fontSize}px "${config.fontFamily}"`;
    ctx.fillStyle = config.color;
    ctx.textAlign = config.align;
    ctx.textBaseline = config.baseline;

    // Text-Schatten für bessere Lesbarkeit
    ctx.shadowColor = 'rgba(255, 255, 255, 0.3)';
    ctx.shadowBlur = 3;
    ctx.shadowOffsetX = 1;
    ctx.shadowOffsetY = 1;

    // Text zeichnen
    ctx.fillText(text, config.x, config.y);

    // Schatten zurücksetzen
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
  },

  /**
   * Details-Zeile zeichnen (Uhrzeit · Gewicht · Größe)
   */
  drawDetailsLine(formData) {
    const parts = [];

    // Uhrzeit formatieren
    if (formData.uhrzeit) {
      parts.push(`${formData.uhrzeit} Uhr`);
    }

    // Gewicht
    if (formData.gewicht) {
      parts.push(`${formData.gewicht} g`);
    }

    // Größe
    if (formData.groesse) {
      parts.push(`${formData.groesse} cm`);
    }

    if (parts.length === 0) return;

    // Zusammensetzen mit Separator
    const config = this.config.detailsConfig;
    const detailsText = parts.join(config.separator);

    const ctx = this.ctx;

    // Font-Style setzen
    ctx.font = `${config.fontSize}px "${config.fontFamily}"`;
    ctx.fillStyle = config.color;
    ctx.textAlign = config.align;
    ctx.textBaseline = config.baseline;

    // Text-Schatten
    ctx.shadowColor = 'rgba(255, 255, 255, 0.3)';
    ctx.shadowBlur = 3;
    ctx.shadowOffsetX = 1;
    ctx.shadowOffsetY = 1;

    // Text zeichnen
    ctx.fillText(detailsText, config.x, config.y);

    // Schatten zurücksetzen
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
  },

  /**
   * Motiv zeichnen
   */
  drawMotiv() {
    if (!this.images.motiv) return;

    const config = this.config.motivConfig;
    const motiv = this.images.motiv;

    // Skalierung berechnen (aspect ratio beibehalten)
    let width = motiv.width;
    let height = motiv.height;

    const scale = Math.min(
      config.maxWidth / width,
      config.maxHeight / height,
      1 // Nicht größer als Original
    );

    width *= scale;
    height *= scale;

    // Zentriert an Position zeichnen
    this.ctx.drawImage(
      motiv,
      config.x - width / 2,
      config.y - height / 2,
      width,
      height
    );
  }
};

// Auto-Initialisierung wenn DOM bereit
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => BirthtreePreview.init());
} else {
  BirthtreePreview.init();
}

// Für Debugging im Browser-Console
window.BirthtreePreview = BirthtreePreview;
